import * as React from "react";
import styled from "@emotion/styled";
import { Text, Button } from "atoms";
import { User } from "features/auth";

type RoleOverrideButtonParams =
  React.ButtonHTMLAttributes<HTMLButtonElement> & {
    role: string;
    user: User;
    adminUserAddDiscordOverride: (user: User, role: string) => void;
    adminUserRemoveDiscordOverride: (user: User, role: string) => void;
  };

function RoleOverrideButton({
  role,
  user,
  adminUserAddDiscordOverride,
  adminUserRemoveDiscordOverride,
  ...props
}: RoleOverrideButtonParams) {
  const hasOverride = user.utilitiesOverride.find((o) => o === role);

  const removeOverride = () => {
    adminUserRemoveDiscordOverride(user, role);
  };

  const addOverride = () => {
    adminUserAddDiscordOverride(user, role);
  };

  return (
    <RoleItems key={role}>
      <RoleButton
        arrow={null}
        {...props}
        onClick={hasOverride ? removeOverride : addOverride}
        type="button"
      >
        {hasOverride ? "Remove" : "Add"}
      </RoleButton>
      <RoleText>{role}</RoleText>
    </RoleItems>
  );
}

const RoleItems = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing.md,
}));

const RoleButton = styled(Button)(({ theme }) => ({
  fontSize: theme.fontSizes.xs,
  justifyContent: "center",
  minHeight: 0,
  padding: ".4em 1em",
  textAlign: "center",
  width: "6rem",
}));

const RoleText = styled(Text)(({ theme }) => ({
  fontWeight: "bold",
  margin: 0,
}));

export { RoleOverrideButton };
